import { Component, computed, inject, input } from '@angular/core';
import { NodeGacon } from '@app/models/entity.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { MediaComponent } from '@app/components/media/media.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ContentLinkService } from '@app/services/contentLinks.service';

@Component({
  selector: 'mobi-node-gacon',
  templateUrl: './node-gacon.component.html',
  styleUrls: ['./node-gacon.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    HeroTextComponent,
    MediaComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeGaconComponent {
  readonly entity = input.required<NodeGacon>();

  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
